export function storedColor(value: unknown, fallback = '#226A73'): string {
  return typeof value === 'string' && /^#[\da-f]{6}$/i.test(value) ? value : fallback;
}
